module.exports = __webpack_public_path__ + "img/hr-puberty-decal-18.87469a57.png";